module.exports = __webpack_public_path__ + "static/1-161c13b53ddbc2a4d8fcbef1094c047b.jpeg";